import { render, staticRenderFns } from "./ResidentCsvTable.vue?vue&type=template&id=5b20547e&lang=pug"
import script from "./ResidentCsvTable.vue?vue&type=script&lang=ts"
export * from "./ResidentCsvTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports